import { useNavigate, useLocation } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function BackButton() {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  if (pathname === "/") return null;

  const goBack = () => {
    const idx = window.history.state?.idx ?? 0;
    if (idx > 0) navigate(-1);
    else navigate("/");
  };

  return (
    <button
      data-testid="back-button"
      onClick={goBack}
      aria-label="Revenir à la page précédente"
      className="fixed bottom-6 left-5 z-40 flex items-center gap-2 rounded-full border border-gold/50 bg-navy/80 px-4 py-2.5 text-sm font-medium text-gold backdrop-blur-md transition-all hover:-translate-x-0.5 hover:bg-gold hover:text-navy lg:left-8"
    >
      <ArrowLeft className="h-4 w-4" strokeWidth={1.8} />
      Retour
    </button>
  );
}
